<template>
  <div class="d-flex justify-content-between">
    <h6>{{ item.workload }} Horas</h6>
    <h5 class="text-success"><b>{{ item.value | formatMoney }}</b></h5>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    }
  }
}
</script>

<style>

</style>
